import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import config from '../../../../config';
import { getAuthToken } from '../../../utils/auth';

const useArticlesStats = () => {
  const [stats, setStats] = useState({
    totalVisits: 0,
    unlockedPosts: 0,
    totalEarnings: 0,
  });

  const publisherId = useSelector((state) => state.user.publisher?.id);
  // const publisherId = 65;

  const accessToken = getAuthToken();

  useEffect(() => {
    if (publisherId) {
      (async () => {
        const payload = {
          category: null,
          country: null,
          endDate: '2021-09-14T08:47:08.227Z',
          publisherId,
          startDate: '2021-07-14T08:47:08.227Z',
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/publisher/accountingStats`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const json = await response.json();

        const { data, message, success } = json;

        if (!success)
          throw new Error(
            message ?? 'Something went wrong. failed to process request'
          );

        // eslint-disable-next-line camelcase
        const { paidUnlocks, gmvTotalUnlocked_USD, totalPageViews } = data;
        setStats({
          // eslint-disable-next-line camelcase
          totalEarnings: gmvTotalUnlocked_USD ?? 0,
          totalVisits: totalPageViews ?? 0,
          unlockedPosts: paidUnlocks ?? 0,
        });
      })();
    }
  }, [publisherId]);

  return stats;
};

export default useArticlesStats;
